/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     接入点充值 接口
  | @Version:   2020-01-03  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const generalApiHost = process.env.VUE_APP_GENERAL_API_HOST;

export function apCartGetallApi(params) {
  return request({
    url: generalApiHost + '/ap/cart/getAll',
    method: 'get',
    params
  })
}

export function apCartListApi(params) {
  return request({
    url: '?c=ap&a=cart&do=list',
    method: 'get',
    params
  })
}

export function apCartPostApi(data) {
  return request({
    url: generalApiHost + '/ap/cart/post',
    method: 'post',
    data
  })
}

export function apCartCalculateApi(params) {
  return request({
    url: generalApiHost + '/ap/cart/calculate',
    method: 'get',
    params
  })
}

export function apCartDeleteApi(data) {
  return request({
    url: '?c=ap&a=cart&do=delete',
    method: 'post',
    data
  })
}

export function apCartClearApi(data) {
  return request({
    url: '?c=ap&a=cart&do=clear',
    method: 'post',
    data
  })
}

export function apCartExpiredApi(data) {
  return request({
    url: generalApiHost + '/ap/cart/expired',
    method: 'post',
    data
  })
}

export function apCartSubmitApi(data) {
  return request({
    url: generalApiHost + '/ap/cart/submit',
    method: 'post',
    data
  })
}
export function dssOptionsApi(params) {
  return request({
    url: generalApiHost + "/ei/dss/getOptions",
    method: "get",
    params
  });
}

export function calculateMultiYearDiscount(params) {
  return request({
    url: generalApiHost + "/ap/cart/calculateMultiYearDiscount",
    method: "get",
    params
  });
}

export function apCartDiscountRateApi(params) {
  return request({
    url: generalApiHost + "/ap/cart/discountRate",
    method: "get",
    params
  });
}